/**
 * Player Shirt Component
 * 
 * Usage:
 * import PlayerShirt from './components/match/PlayerShirt';
 * 
 * <PlayerShirt 
 *   lastName={player?.last_name}
 *   shirtNumber={player?.shirt_number}
 *   color="#bd1313"  // Optional: defaults to red
 * />
 */

import React from 'react';
import Shirt_overlay from '../../images/Shirt_overlay.png';
import '../../scss/match/playerShirt.scss';

const PlayerShirt = ({ lastName = '', shirtNumber = '', color = '#bd1313' }) => {
    return (
        <div className="shirt-container">
            <div className={`team-shirt-container ${color === '#fff' ? 'white-shirt' : ''}`}>
                <div>
                    <span>{lastName}</span>
                    <span className="shirt-number">{shirtNumber}</span>
                    <svg 
                        fill={color} 
                        data-name="Layer 2" 
                        xmlns="http://www.w3.org/2000/svg" 
                        viewBox="0 0 332.2 445.73"
                    >
                        <g id="Layer_1-2" data-name="Layer 1">
                            <path className="cls-1" d="m199.37,4.47l4.04,3.33,3.8,2.38,2.61,4.28,36.36,15.68,22.1,8.55,14.26,5.94s14.73,7.84,17.58,10.93,14.73,19.01,14.73,19.01l11.88,21.62s1.9,8.55,1.9,9.27,2.61,24.48,2.61,24.48l.71,27.09.24,30.18-1.9,1.9-19.96.95h-24.95l-4.99-.48-2.85-3.09-.95,7.6-.24,70.81v115.25s0,59.17,0,59.17l-.95,2.85-4.75,2.14-4.51.24h-61.31s-70.34.71-70.34.71l-51.33-.48-24,.95-5.7-3.8-.71-4.75.71-199.13-.48-25.43-1.43-13.78-1.9-11.41-.95-4.28-1.9,2.61-.24,4.28-37.31.95-8.32-.48-.95-.95.95-52.51,2.85-31.13,6.42-21.39s5.23-13.54,9.27-18.53,14.26-14.73,14.26-14.73l56.55-25.43s17.58-6.18,22.81-11.17,7.37-8.32,7.37-8.32c0,0,19.72-5.7,24.24-6.18s30.18,0,37.78.71,16.87,3.56,16.87,3.56Z"/>
                        </g>
                    </svg>
                    <img 
                        className='shirt-overlay' 
                        src={Shirt_overlay} 
                        alt="Team Shirt" 
                    />
                </div>
            </div>
        </div>
    );
};

export default PlayerShirt; 